<script>
export default {
    props: {
        defaultEmploymentPhases: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            employmentPhases: [...this.defaultEmploymentPhases]
        }
    },

    methods: {
        addEmploymentPhase() {
            this.employmentPhases.push({
                id: null,
                title: '',
                duration: '',
                rate: 0
            })
        },
        removeEmploymentPhase(index) {
            this.employmentPhases.splice(index, 1)
        }
    }
}
</script>

<template>
    <div>
        <div v-if="employmentPhases.length > 0" class="grid-x grid-padding-x mb-2">
            <div class="cell pl-10 ml-10 small-5 large-4">
                <label>Employment Phases:</label>
            </div>

            <div class="cell pl-4 ml-1 small-3 large-3">
                <label>Duration:</label>
            </div>

            <div class="cell pl-4 ml-1 small-3 large-3">
                <label>Rate:</label>
            </div>
        </div>

        <div v-for="(employmentPhase, i) in employmentPhases" class="grid-x grid-padding-x">
            <input v-if="employmentPhase.id" :name="`employment_phase_specs[${i}][id]`" type="hidden"
                :disabled="disabled" required v-model="employmentPhase.id" />

            <div class="cell pl-10 ml-10 pr-0 small-5 large-4">
                <input :name="`employment_phase_specs[${i}][title]`" type="text" :disabled="disabled" required
                    v-model="employmentPhase.title" />
            </div>

            <div class="cell pl-4 ml-1 pr-0 small-3 large-3">
                <input :name="`employment_phase_specs[${i}][duration]`" type="text" :disabled="disabled" required
                    v-model="employmentPhase.duration" />
            </div>

            <div class="cell pl-4 ml-1 small-3 pr-0 large-3">
                <input :name="`employment_phase_specs[${i}][rate]`" type="number" step="0.01" min="0"
                    :disabled="disabled" required v-model="employmentPhase.rate" />
            </div>

            <div class="cell small-1 large-1">
                <div v-if="!disabled" @click="() => removeEmploymentPhase(i)" class="remove-button"><i
                        class="fas fa-minus-circle"></i></div>
            </div>
        </div>

        <div v-if="!disabled" @click="addEmploymentPhase" class="add-button"><i class="fas fa-plus-circle"></i>
        </div>


        <input v-if="employmentPhases.length === 0" name="employment_phase_specs" value="" type="hidden" />
    </div>
</template>